<template>
  <NuxtLayout
    name="main-view"
    :headline="$t('dbc-cancel-contract-button-request-cancellation')"
  >
    <Card :pt="formCardPassThrough">
      <template #content>
        <div class="flex flex-col mt-m gap-s">
          <DbcSvg name="dbc-icon-heart" class="self-center" />
          <FormsCancelContractWeAreSorry class="mx-xs mb-0" />
        </div>
        <FormKit
          :actions="false"
          type="form"
          form-class="rounded-lg"
          @submit="cancelContract"
          #default="{ disabled, state: { valid } }"
          :aria-invalid="errorMessage"
        >
          <DbcBanner
            v-if="errorMessage"
            :message="errorMessage"
            severity="warn"
          />
          <FormsCancelContractReasons @on-reason-changed="onReasonChanged" />
          <FormKit
            type="textarea"
            :name="commentLabel"
            id="comment"
            rows="1"
            maxlength="500"
            :aria-label="commentLabel"
            :placeholder="commentLabel"
            :validation="commentValidation"
          />
          <div class="flex flex-col gap-2xs">
            <FormKit
              type="submit"
              id="submit"
              :label="
                !valid
                  ? $t('dbc-text-fill-in-mandatory-fields')
                  : $t('dbc-cancel-contract-button-request-cancellation')
              "
              :disabled="disabled || !valid || isLoading"
              :loading="isLoading"
              :aria-label="
                !valid
                  ? $t('dbc-text-fill-in-mandatory-fields')
                  : !isLoading
                  ? $t('dbc-cancel-contract-button-request-cancellation')
                  : $t('dbc-text-loading')
              "
            />
            <FormKit
              type="button"
              id="abort"
              @click="
                router.push({
                  path: getPagePath['contract']![locale],
                })
              "
              :label="$t('dbc-btn-abort')"
            />
          </div>
        </FormKit>
      </template>
    </Card>
  </NuxtLayout>
</template>

<script setup lang="ts">
const router = useRouter()
const { t, locale } = useI18n()
import { useCustomerStore } from '../../../../stores/customer'

const customerStore = useCustomerStore()
const { data, contract } = storeToRefs(customerStore)

const errorMessage = ref('')
const isLoading = ref(false)

async function cancelContract(formData: { reason: string; comment: string }) {
  isLoading.value = true

  const cancelContractData: CancelContractData = {
    customerNumber: contract.value?.contractNumber,
    email: data.value?.mail,
    firstName: data.value?.firstName,
    lastName: data.value?.lastName,
    reason: formData.reason,
    textarea: formData.comment,
  }

  const response = await fetchCancelContract(cancelContractData)
  isLoading.value = false

  if (response?.data?.message) {
    errorMessage.value = response.data.message
    return
  } else if (!response.ok) {
    errorMessage.value = t('dbc-error-server-issues')
  }
  if (response.ok && response.status === 200) {
    await customerStore.getContracts()

    router.push({
      path: getPagePath['contract']![locale.value],
      query: { update: 'contract' },
    })
  }
}

const commentValidation = ref('')
const commentLabel = ref<string>(
  t('dbc-cancel-contract-textarea-message-placeholder')
)
function onReasonChanged(reason: CancelContractReason) {
  commentLabel.value = commentLabel.value.replace('*', '')
  commentValidation.value = ''
  if (reason.commentMandatory) {
    commentValidation.value = 'required'
    commentLabel.value += '*'
  }
}
</script>
